export const taglines: string[] = [
  "2024 RCL National Champion",
  "Fairyweight champion of the west.",
  "Pretendgineering",
  "Shedding wheels since 2018.",
  "2wd verts and vert accessories",
  "Losing wheels and catching feels",
  "Overdone is the best kind of done",
  "My body is a machine that turns simple tasks into near-impossible tasks.",
  "Inter-dimensional robot champion."
]; 